export enum _DocumentType {
    DrivingLicense = 1,
    TripTikDocument = 2
}